/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ClientAccessTokenEntity,
  ClientCredentialsAvailabilityEntity,
  GenerateClientAccessTokenResponseEntity,
} from '../models/index';
import {
    ClientAccessTokenEntityFromJSON,
    ClientAccessTokenEntityToJSON,
    ClientCredentialsAvailabilityEntityFromJSON,
    ClientCredentialsAvailabilityEntityToJSON,
    GenerateClientAccessTokenResponseEntityFromJSON,
    GenerateClientAccessTokenResponseEntityToJSON,
} from '../models/index';

export interface GetAccessTokenRequest {
    clientAccessTokenId: string;
}

export interface ListAccessTokenRequest {
    revoked?: boolean;
}

export interface UpdateAccessTokenRequest {
    clientAccessTokenId: string;
}

/**
 * 
 */
export class ClientAuthApi extends runtime.BaseAPI {

    /**
     * アクセストークンを発行する。
     */
    async generateTokenRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GenerateClientAccessTokenResponseEntity>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/clientAuth/oauth/token`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GenerateClientAccessTokenResponseEntityFromJSON(jsonValue));
    }

    /**
     * アクセストークンを発行する。
     */
    async generateToken(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GenerateClientAccessTokenResponseEntity> {
        const response = await this.generateTokenRaw(initOverrides);
        return await response.value();
    }

    /**
     * アクセストークンを1件取得する。
     */
    async getAccessTokenRaw(requestParameters: GetAccessTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClientAccessTokenEntity>> {
        if (requestParameters['clientAccessTokenId'] == null) {
            throw new runtime.RequiredError(
                'clientAccessTokenId',
                'Required parameter "clientAccessTokenId" was null or undefined when calling getAccessToken().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/clientAuth/{clientAccessTokenId}`.replace(`{${"clientAccessTokenId"}}`, encodeURIComponent(String(requestParameters['clientAccessTokenId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClientAccessTokenEntityFromJSON(jsonValue));
    }

    /**
     * アクセストークンを1件取得する。
     */
    async getAccessToken(requestParameters: GetAccessTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClientAccessTokenEntity> {
        const response = await this.getAccessTokenRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * クライアントアクセストークン発行が可能か
     */
    async getClientCredentialsAvailabilityRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClientCredentialsAvailabilityEntity>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/clientAuth/status/client-credentials-availability`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClientCredentialsAvailabilityEntityFromJSON(jsonValue));
    }

    /**
     * クライアントアクセストークン発行が可能か
     */
    async getClientCredentialsAvailability(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClientCredentialsAvailabilityEntity> {
        const response = await this.getClientCredentialsAvailabilityRaw(initOverrides);
        return await response.value();
    }

    /**
     * アクセストークンの一覧を取得する。
     */
    async listAccessTokenRaw(requestParameters: ListAccessTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ClientAccessTokenEntity>>> {
        const queryParameters: any = {};

        if (requestParameters['revoked'] != null) {
            queryParameters['revoked'] = requestParameters['revoked'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/clientAuth`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ClientAccessTokenEntityFromJSON));
    }

    /**
     * アクセストークンの一覧を取得する。
     */
    async listAccessToken(requestParameters: ListAccessTokenRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ClientAccessTokenEntity>> {
        const response = await this.listAccessTokenRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * アクセストークンを取り消す。
     */
    async revokeTokenRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClientAccessTokenEntity>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/clientAuth/oauth/revoke`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClientAccessTokenEntityFromJSON(jsonValue));
    }

    /**
     * アクセストークンを取り消す。
     */
    async revokeToken(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClientAccessTokenEntity> {
        const response = await this.revokeTokenRaw(initOverrides);
        return await response.value();
    }

    /**
     * アクセストークンの名前や説明を更新する。
     */
    async updateAccessTokenRaw(requestParameters: UpdateAccessTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClientAccessTokenEntity>> {
        if (requestParameters['clientAccessTokenId'] == null) {
            throw new runtime.RequiredError(
                'clientAccessTokenId',
                'Required parameter "clientAccessTokenId" was null or undefined when calling updateAccessToken().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/clientAuth/{clientAccessTokenId}`.replace(`{${"clientAccessTokenId"}}`, encodeURIComponent(String(requestParameters['clientAccessTokenId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClientAccessTokenEntityFromJSON(jsonValue));
    }

    /**
     * アクセストークンの名前や説明を更新する。
     */
    async updateAccessToken(requestParameters: UpdateAccessTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClientAccessTokenEntity> {
        const response = await this.updateAccessTokenRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
